<template>
  <div class="info">
    <div class="info__details">
      <h6 class="info__header content-type">learning path</h6>
      <h1 class="info__title content-title" itemprop="abstract">
        {{ title }}
      </h1>
      <p
        v-html="description"
        itemprop="about"
        class="info__description content-description"
      ></p>
    </div>
    <div class="info__progress-wrapper" v-if="isAuthenticated">
      <p class="info__progress lead">
        progress:
        <span class="info__percent-complete data">
          <span v-if="progress">{{ progress }}</span>
          <span v-else>0</span>
          % Complete
        </span>
      </p>
      <ProgressBar :value="progress" class="info__progress-bar" />
      <div class="info__resume-btn-wrapper">
        <button @click="$emit('resume-path')" class="btn btn--primary">
          <PlayIcon />
          <span v-if="progress && progress !== 0">Resume</span>
          <span v-else>Begin</span>
        </button>
      </div>
    </div>
    <div v-if="!isAuthenticated" class="info__cta">
      <SubscriptionRequired :plansLink="plansLink" />
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/properties/ProgressBar.vue'
import SubscriptionRequired from '@/components/properties/SubscriptionRequired.vue'
import PlayIcon from '@/assets/icons/fill/play.svg'

export default {
  name: 'Info',
  components: {
    ProgressBar,
    SubscriptionRequired,
    PlayIcon: { ...PlayIcon, name: 'PlayIcon' },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    progress: {
      type: Number,
      required: false,
    },
    floatedProgress: {
      type: Number,
      required: false,
    },
    pathResume: {
      type: Object,
      required: false,
    },
    plansLink: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.info {
  width: 100%;
  padding-right: 0;
  @include mobile {
    padding-right: 50px;
  }
  @include desktop {
    width: 60%;
    padding-right: 100px;
  }
  &__details {
    margin-bottom: 75px;
  }
  &__progress {
    margin: 0 0 5px 0;
  }
  &__resume-btn-wrapper {
    margin: 35px 0 0 0;
  }
  &__description {
    ::v-deep a {
      color: var(--white);
      text-decoration: underline;
      &:visited {
        color: var(--white);
      }
    }
  }
}
</style>
